const customise = {
  DISCLAIMER: 'disclaimer',
  STOCK_ITEM: { name: 'stock' },
  VARIANT_ITEM: { name: 'variant' },
  SUMMARY_ITEM: { name: 'summary' },
  INSURANCE_BLOCK_ITEM: { name: 'insurance_block' },
  DOM_ID_PREFIX: 'customise_',
  ALL: 'all',
  DEALER: 'Dealer',
};

export default customise;
